import { Slot } from '@radix-ui/react-slot';
import { type VariantProps } from 'class-variance-authority';
import { cn } from '@avanta/shared/utils/cn';
import { badgeVariants } from './styles';

export const Badge = ({
  className,
  size,
  asChild = false,
  ...props
}: React.ComponentProps<'span'> & { size: VariantProps<typeof badgeVariants>['size'] } & {
  asChild?: boolean;
}): React.ReactElement => {
  const Comp = asChild ? Slot : 'span';
  return <Comp data-slot="badge" className={cn(badgeVariants({ size }), className)} {...props} />;
};
